import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Card } from "antd";

import CustomScrollbars from '../../utils/CustomScrollbars'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


function DetailCard({
	key = '',
	pdf = false,
	imageSrc = "",
	documentUrl = "",
	title = "",
	onClick = () => { },
	onLoadSuccess = () => { },
	isNewProduct = false,
	config = "",
	isDetail=false
}) {
	return (
		<Card className="gx-card-widget card-shadow resource-border-radius detail_card" key={key}>
			<div className={`gx-pointer ${isDetail ? 'gx-p-5' : '' }`} onClick={() => onClick()}>
				{!pdf && imageSrc && (<div>
					<div className='h-10'></div>
					<h4 className="gx-my-4 gx-text-center align-center resource-text-clr">{title}</h4>
					<div className="gx-text-center">
						<img alt={title} src={imageSrc} className="products-image"/>
					</div>
				</div>
				)}
				{!pdf && !imageSrc && (
					<div className="">
						<p className="gx-text-left align-center gx-text-black">{title}</p>
					</div>
				)}
				{pdf && (<>
					<h4 className="gx-my-4 gx-text-left align-center resource-text-clr">{title}</h4>
					<Document
						file={documentUrl}
						onLoadSuccess={onLoadSuccess}
					>
						<Page
							pageNumber={1}
							height={90}
							width={120}
							renderTextLayer={false}
						/>
					</Document>
					</>
				)}
			</div>
		</Card>
	);
}

export default DetailCard;
